import type { FeatureFlag } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import { inflection } from '@piccolohealth/util';
import React from 'react';

interface Props extends ChakraV3.TagProps {
  featureFlag: FeatureFlag;
}

export const FeatureFlagTag = (props: Props) => {
  const { featureFlag, ...rest } = props;

  return (
    <ChakraV3.Tag colorPalette='gray' {...rest}>
      {inflection.titleize(featureFlag)}
    </ChakraV3.Tag>
  );
};
